export default function(state=null, action) {

    switch(action.type) {
        
        case "OPTION_SELECTED":
            return action.payload.option;

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReducerActiveOption.js